import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "491728246564";

export default function WhatsAppButton() {
  const handleClick = () => {
    if (window.gtag) window.gtag("event", "whatsapp_click", { location: "floating" });
  };
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hallo Strombaron, ich interessiere mich für einen günstigeren Stromtarif.")}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="fixed bottom-24 left-6 z-[10000] w-14 h-14 rounded-full bg-brand-energy text-white flex items-center justify-center shadow-[0_12px_36px_-8px_rgba(0,200,83,0.6)] hover:scale-110 hover:bg-brand-energyHover transition-transform pulse-ring"
      aria-label="WhatsApp Beratung"
      data-testid="whatsapp-floating-btn"
    >
      <MessageCircle className="w-6 h-6 relative z-10" />
    </a>
  );
}
